import GenericMenu from './menu/GenericMenu'
import Icon from '../atomic/Icon'
import React from 'react'
import { sendGTMData } from '../../utils/gtm'
import { useTrans } from 'hooks'

const Footer = React.memo(() => {

  const t = useTrans()

  const socials = [
    { key: 'facebook', url: 'https://it-it.facebook.com/giuntiscuola/', label: t("Facebook"), icon: "facebook", gtmValue: 'facebook' },
    { key: 'instagram', url: "https://www.instagram.com/giunti_scuola/", label: t("Instagram"), icon: "instagram", gtmValue: 'instagram' },
    { key: 'youtube', url: "https://www.youtube.com/user/GiuntiScuola", label: t("Youtube"), icon: "youtube", gtmValue: 'youtube' },
    { key: 'vimeo', url: "https://vimeo.com/giuntiscuola", label: t("Vimeo"), icon: 'vimeo', gtmValue: 'vimeo' },
    { key: 'pinterest', url: "https://www.pinterest.it/giuntiscuola/", label: t("Pinterest"), icon: "pinterest", gtmValue: 'pinterest'},
    { key: 'linkedin', url: "https://www.linkedin.com/company/giuntiscuola/", label: t("Linkedin"), icon: "linkedin", gtmValue: 'linkedin' },
  ]

  const handleGTM = (itemType, item) => {
    if (itemType == 'newsletter') {
      sendGTMData({
        event: 'GAevent',
        eventID: '07',
        eventCategory: 'newsletter',
        eventAction: 'iscrizione_nl',
        eventLabel: 'iscrizione_nl_ok',
      })
    }

    if (itemType && item) {
      if (itemType == 'footer') {
        sendGTMData({
          event: 'GAevent',
          eventID: '04',
          eventCategory: 'footer',
          eventAction: item,
          eventLabel: 'non_valorizzata',
        })
      }
      if (itemType == 'social') {
        sendGTMData({
          event: 'GAevent',
          eventID: '06',
          eventCategory: 'social',
          eventAction: item,
          eventLabel: 'non_valorizzata',
        })
      }
    }
  }


  return (
    <footer id="footer">
      <div className="footer__content">
        <div className="footer__logo">
          <a
            href="/"
            aria-label={t("Giunti scuola")}
            className="footer__logo-link"
            onClick={() => handleGTM('footer', 'logo_footer')}
          >
            <Icon id="logo-giuntiscuola-color" />
          </a>
        </div>
        <div className="footer__center">
          <GenericMenu id="footer" classes="footer" />
        </div>
        <div className="footer__right">
          <ul role="menu" className="footer__social">
            {socials.map(s => (
              <li key={s.key} role="none" className={`footer__social-item footer__social-item--${s.key}`}>
                <a
                  role="menuitem"
                  href={s.url}
                  target="_blank"
                  aria-label={s.label}
                  onClick={() => handleGTM('social', s.gtmValue)}
                >
                  <Icon id={s.icon} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="footer-credits">
        <div className="footer-credits__content">
          <div className="footer-credits__copy">
            Copyright © {new Date().getFullYear()} Giunti Scuola P. IVA 05492160485, tutti i diritti
            riservati
          </div>
          <ul role="menu" className="footer-credits__links">
            <li role="none" className="footer-credits__link">
              <a role="menuitem" href={t('/condizioni-di-vendita')}>{t('Condizioni di vendita')}</a>
            </li>
            <li className="footer-credits__link" >
              <button type="button" onClick={() => Cookiebot.renew()}>{t('Gestisci i cookie')}</button>
            </li>
            <li className="footer-credits__link">
              <a
                href="https://gruppogiunti.magnewsemail.com/nl/gruppogiunti_page1637.mn"
                onClick={() => handleGTM('newsletter')}
                target="_blank"
              >
                Iscriviti alla newsletter
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
})

export default Footer
